import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule, DeferLoadingStrategy } from '@spartacus/core';
import { MediaModule } from '@spartacus/storefront';
import { SharedModule } from 'src/app/shared/shared.module';
import { LoginFooterComponent } from './login-footer.component';

@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    MediaModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ShimanoLoginFooterComponent: {
          component: LoginFooterComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    } as CmsConfig),
    LoginFooterComponent,
  ],
})
export class LoginFooterModule {}
